<template>
  <b-table
    id="print-class"
    :data="data"
    @dblclick="showSelected"
    @click="setSelected"
    :selected.sync="selectedData"
    :row-class="(row, index) => checkColor(row)"
    striped
    hoverable
  >
    <template slot-scope="props">
      <b-table-column field="id-number" width="70" label="#">{{ props.row.internal_id }}</b-table-column>
      <b-table-column
        field="program"
        width="50"
        label="Программа"
      >{{ findProgram(props.row.service_id, 'name') }} {{props.row.additional_service_id ? `(${findProgram(props.row.additional_service_id, 'name')})` : ''}}</b-table-column>
      <b-table-column
        field="weight"
        label="Вага (кг)"
      >{{ props.row.rounded_weight }}кг</b-table-column>
      <b-table-column field="price" label="Ціна">{{props.row.price}} грн</b-table-column>
      <b-table-column field="client" label="Клієнт">{{props.row.name}}</b-table-column>
      <b-table-column field="card_id" label="Картка">
        <strong
          class="tag is-success"
          v-if="props.row.card_id"
          @click="checkCashBack(props.row.card_id)"
        >{{cartMask(props.row.card_id)}}</strong>
      </b-table-column>
      <b-table-column field="paid" label="Оплачено">
        <p v-if="props.row.paid">{{checkPaid(props.row.paid)}}</p>
        <b-dropdown class="has-text-black" v-else hoverable aria-role="list">
          <button class="button is-small is-warning" slot="trigger">
            <span>оплатить</span>
            <b-icon icon="menu-down"></b-icon>
          </button>

          <b-dropdown-item @click="toPay(props.row, 1)" aria-role="listitem">Наличкой</b-dropdown-item>
          <b-dropdown-item @click="toPay(props.row, 2)" aria-role="listitem">Терминал</b-dropdown-item>
          <b-dropdown-item @click="toPay(props.row, 3)" aria-role="listitem">Бонусами</b-dropdown-item>
        </b-dropdown>
      </b-table-column>
      <b-table-column field="completed" label="Статус">
        <p v-if="props.row.status == 2">Получено клиентом</p>
        <b-dropdown class="has-text-black" v-else hoverable aria-role="list">
          <button @click="setStatus(props.row)" class="button is-small is-warning" slot="trigger">
            <span v-if="props.row.status == 1">готово к выдаче</span>
            <span v-else>в работе</span>
            <b-icon icon="menu-down"></b-icon>
          </button>

          <b-dropdown-item
            v-if="props.row.status != 1"
            @click="setStatus(props.row, 1)"
            aria-role="listitem"
          >готово к выдаче</b-dropdown-item>
          <b-dropdown-item @click="setStatus(props.row, 2)" aria-role="listitem">Завершить</b-dropdown-item>
        </b-dropdown>
      </b-table-column>

      <b-table-column field="moved" label="Друга пральня">
        <b-switch :value="props.row.moved === 1" @input="updateProcessMoved(props.row)">
          {{ props.row.moved === 1 ? 'Так' : 'Ні' }}
        </b-switch>
      </b-table-column>

      <b-table-column width="120" field="buttons" label>
        <button class="button" @click="print(props.row)">
          <b-icon icon="printer"></b-icon>
        </button>
        <button
          class="button mgl-1"
          :class="{'is-dark' : props.row.sms_sent_at}"
          @click="sentSms(props.row)"
        >
          <b-icon icon="message-text"></b-icon>
        </button>
      </b-table-column>
    </template>
    <template slot="footer" v-if="showFooter">
      <div
        class="has-text-right"
      >Клиентов: {{data.length}} | Килограм: {{mass}} | На сумму: {{summ}} | Бонусів: {{cashBack}}</div>
    </template>
  </b-table>
</template>

<script>
import { mapState, mapActions } from "vuex";
import printing from "@/utils/printing.js";

export default {
  props: ["selected", "data", "showFooter"],
  data() {
    return {
      selectedData: null
    };
  },
  computed: {
    ...mapState(["services"]),
    mass() {
      let sum = 0;
      this.data.forEach(a => (sum += a.rounded_weight));
      return sum;
    },
    summ() {
      let sum = 0;
      let filtered = this.data.filter(el => el.paid !== 3);
      filtered.forEach(a => (sum += a.price));
      return sum;
    },
    cashBack() {
      return this.summ * 0.1;
    }
    // selectedData: {
    //   get() {
    //     return this.selected;
    //   },
    //   set(val) {
    //     this.$emit("setSelected", val);
    //   }
    // }
  },
  methods: {
    printing,
    ...mapActions(["getCosts", "getProcesses", "getCards", "editProcesses"]),
    async print(row) {
      let service = this.services.find(({ id }) => id == row.service_id);
      let payment =
        row.paid == 1
          ? "Готівка"
          : row.paid == 2
          ? "Картка"
          : row.paid == 3
          ? "Бонуси"
          : null;
      await this.printing(row, service, payment, row.price);
      window.print();
    },
    refresh() {
      this.$emit("refresh");
    },
    checkPaid(x) {
      if (x == 1) return "Наличкой";
      if (x == 2) return "Карткой";
      return "Бонусами";
    },
    showSelected() {
      this.$emit("showSelected");
      this.setSelected();
    },
    setSelected() {
      setTimeout(() => this.$emit("setSelected", this.selectedData), 200);
    },
    checkColor(row) {
      if (row.status == 1) return "yellow";
      if (row.status == 2) return "grean";
      if (row.moved == 1) return "moved";

      return;
    },
    async setStatus(x, type) {
      let status = type ? type : x.status == 0 ? 1 : 2;
      await this.editProcesses({
        point: `processes/${x.id}/do/${status}`
      })
        .then(() => {
          this.refresh();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            duration: 3000,
            message: `Не получилось`,
            position: "is-top"
          });
        });
    },
    async sentSms(x) {
      return await this.editProcesses({
        point: `processes/${x.id}/sms`
      }).then(() => {
        this.$buefy.snackbar.open({
          duration: 3000,
          message: `СМС отправлено`,
          position: "is-top"
        });
      });
    },
    async toPay(x, type) {
      if (x.paid > 0) return;

      return await this.editProcesses({
        point: `processes/${x.id}/pay/${type}`
      })
        .then(() => {
          this.refresh();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            duration: 3000,
            message: `Не получилось`,
            position: "is-top"
          });
        });
    },

    checkCashBack(number) {
      this.getCards({
        url: `cards/${this.cartMask(number)}`
      }).then(res => {
        this.$buefy.snackbar.open({
          duration: 3000,
          message: `Сейча ${res.bonuses} бонусних кілограм`,
          position: "is-top"
        });
      });
    },
    findProgram(x, v) {
      let find = this.services.find(({ id }) => id == x);
      if (find && v == "name") return find.name;
      if (find && v == "price") return find.price;
      return find || null;
    },
    price(row) {
      return (
        Number(row.rounded_weight) * this.findProgram(row.service_id, "price")
      );
    },
    cartMask(number) {
      const length = 4 - String(number).length;
      let str = "";
      for (let index = 0; index < length; index++) {
        str = str + "0";
      }
      return str + String(number);
    },

    async updateProcessMoved ({ id, moved }) {
      await this.$store.dispatch('editProcesses', {
        method: 'post',
        process: {
          moved: !(moved === 1)
        },
        point: `processes/${id}`
      })

      this.refresh();
    }
  }
};
</script>
